import gql from 'graphql-tag';

import DAILY_BRIEF_FRAGMENT from './DAILY_BRIEF_FRAGMENT';

export const GET_SERVICE_RUNS_DAILY_BRIEF = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: ServiceRunPageFilter
	) {
		getServiceRuns(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...serviceRunDailyBrief
			}
			count
		}
	}
	${DAILY_BRIEF_FRAGMENT}
`;

export default GET_SERVICE_RUNS_DAILY_BRIEF;
